import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 商城免单
export default [{
  path: "/free/freeCharge",
  name: "freeCharge",
  component: function component() {
    return import("../../../views/freeCharge/freeCharge.vue");
  },
  meta: {
    title: "商城免单",
    foot: true
  }
}];